import { apiClient } from './client';
import type { PaginatedResponse } from '../types/api';
import type { CustomerOrder, CustomerOrderCreate, OrderBlankDemandItem } from '../types/orders';

const BASE = '/orders/';

interface OrderListParams {
  page?: number;
  page_size?: number;
  status?: string;
  customer?: number;
  /** Номер із картки замовника (пошук по входженню) */
  external_number?: string;
  /** Лише замовлення-ВДР (виріб для розробки) */
  is_development?: boolean;
  ordering?: string;
}

export const ordersApi = {
  list: (params?: OrderListParams) =>
    apiClient.get<PaginatedResponse<CustomerOrder>>(BASE, { params }).then((r) => r.data),

  get: (id: number) => apiClient.get<CustomerOrder>(`${BASE}${id}/`).then((r) => r.data),

  create: (data: CustomerOrderCreate) =>
    apiClient.post<CustomerOrder>(BASE, data).then((r) => r.data),

  patch: (id: number, data: Partial<CustomerOrderCreate>) =>
    apiClient.patch<CustomerOrder>(`${BASE}${id}/`, data).then((r) => r.data),

  cancel: (id: number) => apiClient.post<CustomerOrder>(`${BASE}${id}/cancel/`).then((r) => r.data),

  /**
   * «Взяти в роботу»: new -> in_work. З цього моменту позиції замовлення
   * зʼявляються в черзі заготівельного цеху. Бек дозволяє лише зі статусу
   * «Нове» і лише коли в замовленні є позиції — інакше 400 з `detail`.
   */
  startWork: (id: number) =>
    apiClient.post<CustomerOrder>(`${BASE}${id}/start-work/`).then((r) => r.data),

  blankDemand: (id: number) =>
    apiClient.get<OrderBlankDemandItem[]>(`${BASE}${id}/blank-demand/`).then((r) => r.data),
};
